import React, { useContext } from 'react';
import SubjectsList from 'views/Main/components/SubjectsList';
import { QuestionApiResponse } from 'types/Questions.types';
import QuestionsList from 'components/QuestionsList';
import Banner from 'views/QuestionsWithCategories/components/Banners';
import useWindowWidth from 'utils/useWindowWidth';
import Intro from 'views/Main/components/Intro';
import { CountByCategoriesResponse } from 'views/Main/types/getCountByCategories';
import { configuratorContext } from 'context/ConfiguratorContext';
import VKAd from 'components/VKAd';
import { appAuthContext } from 'context/AuthContext';
import styles from './Main.module.css';

type MainProps = {
  data: QuestionApiResponse | null;
  page: number;
  countByCategories: CountByCategoriesResponse | null;
};

const Main = ({ data, page, countByCategories }: MainProps) => {
  const { user } = useContext(appAuthContext);
  const { banners } = useContext(configuratorContext);
  const deviceWidth = useWindowWidth();

  const itsLastPage = data?.totalPages && +page === data.totalPages;
  const showDesktopBanner = deviceWidth > 1023 && deviceWidth > 0;

  return (
    <>
      <Intro />
      <div className={styles.wrapper}>
        <SubjectsList countByCategories={countByCategories} />
        <h2 className={styles.title} data-qa-marker="main_page_title">
          Новые вопросы
        </h2>
        <main className={styles.content}>
          <div className={styles.container}>
            {data && (
              <QuestionsList
                data={data}
                banner={{
                  horizontalBannerPosition: 4,
                  eventInfo: 'banner_side_mobile',
                }}
              />
            )}
            <div className={styles.sidebar}>
              {showDesktopBanner && banners?.otvety_side_banners && (
                <Banner
                  width={300}
                  height={418}
                  className={`${styles.banner} ${
                    itsLastPage ? styles.banner__last_page : ''
                  }`}
                  linkFromBanner={banners?.otvety_side_banners?.link}
                  imageUrl={banners?.otvety_side_banners?.images?.desktop}
                  bannerName={banners?.otvety_side_banners?.name}
                  bannerType="desktop"
                  eventInfo="banner_side"
                />
              )}
              {banners?.otvety_side_banners === null &&
                showDesktopBanner &&
                !user?.data?.attributes && (
                  <VKAd slotId="1531120" maxWidth="300px" maxHeight="600px" />
                )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Main;
